import {
  SEARCH_SERVICE_REQUEST_FAIL,
  SEARCH_SERVICE_REQUEST_SUCCESS,
  RESET_SERVICE_SEARCH
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.searchContact, action) => {
  switch (action.type) {
    case SEARCH_SERVICE_REQUEST_SUCCESS:
      return [...action.payload]
    case SEARCH_SERVICE_REQUEST_FAIL:
      return state
    case RESET_SERVICE_SEARCH:
      return InitialState.searchService
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/service/searchservice.reducer.js